// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-2vflq";
var _3 = "return__massage-1HZaV";
var _4 = "return__massage__icon-1ZmFp";
export { _1 as "__esModule", _2 as "wrapper", _3 as "return__massage", _4 as "return__massage__icon" }
export default { "__esModule": _1, "wrapper": _2, "return__massage": _3, "return__massage__icon": _4 }
